import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import { useState } from 'react';
import useRootClose from "react-overlays/useRootClose";

var RootClose = function RootClose(_ref) {
  var children = _ref.children,
      onRootClose = _ref.onRootClose,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "onRootClose"]);

  var _useState = useState(null),
      rootElement = _useState[0],
      attachRef = _useState[1];

  useRootClose(rootElement, onRootClose, props);
  return children(attachRef);
};

export default RootClose;